module.exports = __webpack_public_path__ + "static/img/introduce_3.07ed0ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce_3.png
// module id = 5P5n
// module chunks = 1